<script lang="ts">
  import HeroButton from './HeroButton.svelte';
  import StepProgress from './StepProgress.svelte';
  import { createEventDispatcher } from 'svelte';
  import type { Item } from '../../types';

  export let pollsSum: number;
  export let services: { value: string; label: string }[] = [];
  export let selected: string[] = [];
  export let data: Item;
  export let title: string;
  export let step: number;

  const dispatch = createEventDispatcher();
  let selectedLocal = [...selected];
  let showError = false;

  $: {
    selectedLocal = [];
    showError = false;
  }

  function toggleService(value: string) {
    if (selectedLocal.includes(value)) {
      selectedLocal = selectedLocal.filter(v => v !== value);
    } else {
      selectedLocal = [...selectedLocal, value];
    }
    showError = false;
  }

  function handleNext() {
    if (selectedLocal.length === 0) {
      showError = true;
      return;
    }

    dispatch('next', {
      selected: selectedLocal,
      questionKey: transformString(services[0]?.label || ''),
      question: services[0]?.label || '',
    });

    selectedLocal = [];
  }

  function transformString(inputString: string) {
    const cleanedString = inputString.replace(/[^a-zA-Z0-9\s]/g, '');
    const lowercasedString = cleanedString.toLowerCase();
    return lowercasedString.replace(/\s+/g, '-');
  }
</script>

<div
  class="flex h-full w-full flex-col rounded-3xl bg-[#B3D18433] px-4 py-5 md:px-10 md:py-10"
>
  <StepProgress {pollsSum} {title} {step} />

  <div class="mb-4 space-y-3">
    <h5 class="text-normal !font-semibold leading-normal">
      {data.title.value}
    </h5>
    <p class="text-xs !font-medium leading-normal !text-[#111111A3]">
      Select all that apply:
    </p>
  </div>
  <div class="w-full space-y-3">
    {#each services as service}
      <label
        class="flex w-full cursor-pointer items-center gap-2 rounded-lg bg-white p-4"
      >
        <input
          type="checkbox"
          class="hidden"
          checked={selectedLocal.includes(service.value)}
          on:change={() => toggleService(service.value)}
        />
        <div
          class="my-0.5 flex h-4 w-4 items-center justify-center rounded border"
          style="border-color: {selectedLocal.includes(service.value)
            ? '#086CD9'
            : '#E4E4E7'}"
        >
          {#if selectedLocal.includes(service.value)}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M10 3L4.5 8.5L2 6"
                stroke="#086CD9"
                stroke-width="1.6666"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          {/if}
        </div>
        <p class="grow-1 flex-1 text-sm !font-semibold leading-5">
          {service.label}
        </p>
      </label>
    {/each}
  </div>

  {#if showError}
    <p class="mt-2 text-sm text-red-500">Please select at least one option</p>
  {/if}

  <div class="mt-auto w-full">
    <div class="mt-4 md:my-8">
      <HeroButton text={data.button.value} onClick={handleNext} />
    </div>
    <p
      class="hidden text-center text-xs !font-medium leading-normal !text-[#111111A3] md:block"
    >
      Zero Spam Policy
    </p>
  </div>
</div>
